export default "__VITE_ASSET__e34b0221__"